import { useEffect, useState, type MutableRefObject } from "react";
import type { IdeaChannel, PairingClient } from "../protocol";

/** The selected session's live idea channels. Resubscribes when the selection changes. */
export function useIdeaChannels(
  clients: MutableRefObject<Map<string, PairingClient>>,
  selected: string | null,
  /** From useSessions — re-runs the subscription once the client for this selection exists (see useSessions). */
  clientsVersion: number,
): IdeaChannel[] {
  const [channels, setChannels] = useState<IdeaChannel[]>([]);
  useEffect(() => {
    setChannels([]);
    if (!selected) return;
    const [pid, sid] = selected.split("/");
    // Ideas only: the subscription carries every channel of the session, the main chat among them, and the
    // board, the tab count and the spec rail are all about ideas.
    const unsub = clients.current.get(pid)?.subscribeChannels(sid, (all) => setChannels(all.filter((c) => c.kind === "idea")));
    return () => unsub?.();
  }, [selected, clientsVersion]);
  return channels;
}
